import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from "../Assets/Logo/Icon-modified.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faPhone, faClock, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer className="text-gray-300">

      {/* ── Main Section ── */}
      <div className="bg-[rgb(22,30,42)]">
        <div className="max-w-7xl mx-auto py-14 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">

            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <img src={logoImage} alt="Selection Lenses" className="w-14 h-14" />
                <span className="text-white text-xl font-bold tracking-wide">Selection Lenses</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-5">
                Your trusted destination for premium contact lenses. Quality products, fast delivery, and expert care.
              </p>
              {/* Social */}
              <div className="flex items-center gap-4">
                <a href="https://wa.me/201500463555" aria-label="WhatsApp" target="_blank" rel="noreferrer"
                  className="w-10 h-10 sm:w-9 sm:h-9 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition-colors duration-200">
                  <FontAwesomeIcon icon={faWhatsapp} className="text-sm" />
                </a>
                <a href="https://www.facebook.com/share/1Ey7yGB4ae/" aria-label="Facebook" target="_blank" rel="noreferrer"
                  className="w-10 h-10 sm:w-9 sm:h-9 rounded-full bg-white/10 hover:bg-[#1877F2] flex items-center justify-center transition-colors duration-200">
                  <FontAwesomeIcon icon={faFacebookF} className="text-sm" />
                </a>
                <a href="https://www.instagram.com/" aria-label="Instagram" target="_blank" rel="noreferrer"
                  className="w-10 h-10 sm:w-9 sm:h-9 rounded-full bg-white/10 hover:bg-[#E4405F] flex items-center justify-center transition-colors duration-200">
                  <FontAwesomeIcon icon={faInstagram} className="text-sm" />
                </a>
                <a href="https://www.tiktok.com/" aria-label="TikTok" target="_blank" rel="noreferrer"
                  className="w-10 h-10 sm:w-9 sm:h-9 rounded-full bg-white/10 hover:bg-white hover:text-black flex items-center justify-center transition-colors duration-200">
                  <FontAwesomeIcon icon={faTiktok} className="text-sm" />
                </a>
              </div>
            </div>

            {/* Categories */}
            <div>
              <h3 className="text-white text-base font-semibold mb-5 uppercase tracking-widest">Shop</h3>
              <ul className="space-y-3 text-sm">
                {[
                  { label: 'Colored Lenses', slug: 'colored-lenses' },
                  { label: 'Clear Lenses', slug: 'clear-lenses' },
                  { label: 'Accessories', slug: 'accessories' },
                ].map(({ label, slug }) => (
                  <li key={slug}>
                    <Link
                      to={`/products/${slug}`}
                      className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-brand-500 inline-block" />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-white text-base font-semibold mb-5 uppercase tracking-widest">Contact Us</h3>
              <ul className="space-y-4 text-sm text-gray-400">
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faLocationDot} className="text-brand-500 mt-0.5 shrink-0" />
                  <span>Tanta - Moheb St. across Saied St., Egypt</span>
                </li>
                <li className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faPhone} className="text-brand-500 shrink-0" />
                  <a href="tel:+201500463555" className="hover:text-white transition-colors">+20 150 046 3555</a>
                </li>
                <li className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faEnvelope} className="text-brand-500 shrink-0" />
                  <a href="mailto:selection-lenses@selection-lenses.com" className="hover:text-white transition-colors break-all">selection-lenses@selection-lenses.com</a>
                </li>
                <li className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faClock} className="text-brand-500 shrink-0" />
                  <span>Sat – Thu: 10:00 AM – 10:00 PM</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="bg-[rgb(14,20,30)] py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Selection Lenses. All Rights Reserved.
          </span>
          <span className="text-xs text-gray-600">
            Powered by Selection Lenses
          </span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
